module.exports = __webpack_public_path__ + "media/assets/phone-f7435a6ffc1cfd59c5dc90807664a3dc2d170691c25e761112d0b370ce3f9f95.svg";